export const MULTIPLE_ROLE_STORAGE_KEY = 'multipleRole';
